import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { Space, Row, Spinner } from "@masterteam/mt-design-react";
import InitiativesList from "./InitiativesList";
import { addToast } from "../../helpers";
import api from "../../providers/api";

import "./style.scss";

const Initiatives = () => {
  const [loading, setLoading] = useState(false);
  const [initiatives, setInitiatives] = useState([]);

  const getInitiatives = async () => {
    setLoading(true);
    try {
      const res = await api.initiatives.getAll();
      setInitiatives(res.Data);
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getInitiatives();
  }, []);

  return (
    <Space direction="vertical" size="large" className="initiatives-container">
      <Row className="title-wrapper">
        <FormattedMessage id={`common.initiatives`} />
      </Row>
      {loading ? (
        <Row justify="center">
          <Spinner size="large" />
        </Row>
      ) : (
        <InitiativesList initiatives={initiatives} />
      )}
    </Space>
  );
};

export default Initiatives;
